<template>
  <div class="swiper-theme swiper-theme--vue swiper-theme--primary">
    <swiper
      :modules="modules"
      :slides-per-view="props.slidesPerView"
      :space-between="props.spaceBetween"
      :navigation="props.showNavigation"
      :pagination="props.showPagination ? { 'clickable': true } : false"
    >
      <swiper-slide
        v-for="(item, index) in items"
        :key="index"
      >
        <slot :item="item"></slot>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>

/**
 *  Documentation: https://swiperjs.com/swiper-api
 *
 *  Use case example when implemented in template:
 *
 *  <adivare-swiper-primary
 *    :items="cancellationReviews"
 *    v-slot="slotProps"
 *    show-navigation
 *    show-pagination
 *  >
 *    <adivare-cancellation-review :cancellationReview="slotProps.item"/>
 *  </adivare-swiper-primary>
 */

import {
  Navigation,
  Pagination,
  Autoplay,
} from 'swiper';

import {
  Swiper,
  SwiperSlide
} from 'swiper/vue';

export default {
  name: 'adivare-swiper-primary',
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    // items in swipe slider
    items: {
      type: Array,
      required: true,
    },
    // show navigation. This is the next and previous button. Default is false.
    showNavigation: {
      type: Boolean,
      default: false,
      required: false,
    },
    // show pagination. The dots underneath the slider. Default is false.
    showPagination: {
      type: Boolean,
      default: false,
      required: false,
    },
    // Time in milliseconds when next view is rendered. Autoplay is disabled when autoplay-speed is not set
    autoplaySpeed: {
      type: Number,
      default: false,
      required: false,
    },
    // show total slides at the same time. Default is 1
    slidesPerView: {
      type: Number,
      default: 1,
      required: false,
    },
    // set space between slides. Default is 30px.
    spaceBetween: {
      type: Number,
      default: 30,
      required: false,
    },
  },
  setup(props) {
    return {
      props,
      modules: [Navigation, Pagination, Autoplay],
    }
  },
};
</script>
